
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ShoppingCart, Link, Smartphone, Laptop, Package } from 'lucide-react';

const ShopwareFeatures = () => {
  return (
    <section id="shopware-features" className="py-16 md:py-24">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Warum ein professioneller Shopware-Shop entscheidend ist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Egal, ob du einen neuen B2B- oder B2C-Shop starten oder einen bestehenden optimieren möchtest – 
            eine leistungsfähige, gut strukturierte Shopware-Umsetzung entscheidet über deinen Erfolg im E-Commerce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <ShoppingCart className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Shopware B2C & B2B Entwicklung</h3>
              <p className="text-gray-600">
                Ob du Produkte an Endkunden (B2C) oder Geschäftskunden (B2B) verkaufst – wir entwickeln maßgeschneiderte 
                Lösungen, die sich perfekt an deine Anforderungen anpassen.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Link className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Headless-Ansatz</h3>
              <p className="text-gray-600">
                Shopware bietet einen hochmodernen Headless-API Ansatz, damit kann dein Shop 
                sich mit allen Systemen unterhalten und maximale Flexibilität bieten.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Package className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Individuelles Design & UX</h3>
              <p className="text-gray-600">
                Ein guter Shop verkauft nicht nur – er begeistert. Wir setzen auf modernes, conversionstarkes 
                Design und eine intuitive Benutzerführung für maximale Verkaufszahlen.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Link className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Schnittstellen & ERP-Integration</h3>
              <p className="text-gray-600">
                Perfekte Anbindung an ERP, CRM, Zahlungsanbieter, Marktplätze und Versanddienstleister. 
                Wir sorgen für eine reibungslos funktionierende Infrastruktur.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Laptop className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Performance-Optimierung</h3>
              <p className="text-gray-600">
                Schnelle Ladezeiten = höhere Conversion-Raten. Wir optimieren deinen Shop für maximale 
                Geschwindigkeit und Stabilität – auch bei hoher Last.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Smartphone className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Mobile First & Responsive</h3>
              <p className="text-gray-600">
                Deine Kunden kaufen auf Smartphone, Tablet oder Desktop – wir sorgen dafür, 
                dass dein Shop auf jedem Gerät perfekt funktioniert.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ShopwareFeatures;
